import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { EFN_KEYCLOAK_SCOPE } from "../Keycloak";

const LoginOrLogoutButton = () => {
    const { keycloak, initialized } = useKeycloak();

    function accountProfileUrl() {
        const defaultAccountUrl = `${window.location.origin}/`;

        if (!keycloak?.createAccountUrl) {
            return defaultAccountUrl;
        }

        try {
            const accountUrl = new URL(
                keycloak.createAccountUrl({ redirectUri: defaultAccountUrl })
            );
            accountUrl.hash = "/personal-info";
            return accountUrl.toString();
        } catch (error) {
            console.error("Could not build account profile URL", error);
            return keycloak.createAccountUrl({ redirectUri: defaultAccountUrl });
        }
    }

    function loginButton() {
        return (
                <button
                    type="button"
                    className="login-button"
                    onClick={() => keycloak.login({ scope: EFN_KEYCLOAK_SCOPE })}
                >
                    Login
                </button>
            );
    }

    function profileButton(className = "profile-link-button") {
        return (
            <a
                className={className}
                href={accountProfileUrl()}
                aria-label="User profile"
                title="User profile"
            >
                <svg
                    aria-hidden="true"
                    className="profile-link-icon"
                    viewBox="0 0 24 24"
                    focusable="false"
                >
                    <path
                        d="M12 12.25a4.25 4.25 0 1 0-4.25-4.25A4.25 4.25 0 0 0 12 12.25Zm0 1.5c-4.43 0-8 2.35-8 5.25a.75.75 0 0 0 .75.75h14.5A.75.75 0 0 0 20 19c0-2.9-3.57-5.25-8-5.25Z"
                        fill="currentColor"
                    />
                </svg>
                <span className="visually-hidden">User profile</span>
            </a>
        );
    }

    function logoutButton() {
        return  (
            <button
                    type="button"
                    className="logout-button"
                    onClick={() => keycloak.logout()}
                >
                    Logout  ({keycloak.tokenParsed.preferred_username})
                </button>
        );
    }

    function loginOrLogoutButton() {
        if (keycloak.authenticated) {
            console.log("cka = True")
        } else {
            console.log("cka = False")
        }
                if (initialized) {
                    console.log("Is Initialized");
                    console.log("token parsed = ", keycloak.tokenParsed)
                    if (keycloak.authenticated) {
                        console.log("Keycloak  is authenticated= ", keycloak)
                        return (
                            <>
                                {profileButton("profile-link-button profile-link-button--corner")}
                                {logoutButton()}
                            </>
                        );
                    }
                    else {
                        return loginButton();
                    }
               } else {
                    console.log("Is not Initialized");
                    console.log("keycloak.authenticated = ", keycloak.authenticated)
                    console.log("Keycloak = ", keycloak)
                    return loginButton();
                }
    }

    return (<nav className="auth-actions"> {loginOrLogoutButton()} </nav>
    );
};

export default LoginOrLogoutButton;
